import {
  CheckCircleIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/20/solid';
import { DuctRunSuppliesType } from 'utils/duct-supplies';
import { withOccurrenceKeys } from 'utils/unique-keys';

type DuctRunSuppliesGroupProps = Readonly<{
  run: DuctRunSuppliesType;
}>;

export default function DuctRunSuppliesGroup({
  run
}: DuctRunSuppliesGroupProps) {
  const covered = run.coveredByLabel !== null;
  return (
    <div className='flex flex-col gap-0.5'>
      <div className='flex flex-wrap items-baseline gap-x-2 gap-y-0.5'>
        <span className='text-xs font-semibold text-gray-700'>
          {run.heading}
        </span>
        {covered && (
          <span className='inline-flex items-center gap-1 text-xs font-semibold text-green-700'>
            <CheckCircleIcon className='h-3.5 w-3.5 shrink-0' />
            {run.coveredByLabel}
          </span>
        )}
      </div>
      {!covered &&
        withOccurrenceKeys(
          run.lines,
          (line) => `${line.quantity}-${line.label}`
        ).map(({ key, item: line }) => (
          <div
            key={key}
            className='flex items-baseline gap-2 pl-3 text-xs text-gray-600'
          >
            <span className='w-8 shrink-0 text-right font-semibold'>
              {line.quantity}
            </span>
            <span className='inline-flex items-center gap-1'>
              {line.status === 'found' && (
                <CheckCircleIcon className='h-3.5 w-3.5 shrink-0 self-center text-green-600' />
              )}
              {line.status === 'missing' && (
                <ExclamationTriangleIcon className='h-3.5 w-3.5 shrink-0 self-center text-amber-500' />
              )}
              {line.label}
            </span>
          </div>
        ))}
    </div>
  );
}
